import React from "react";
import { withRouter } from "react-router-dom";
import { Layout, Menu } from "antd";
import { SolutionOutlined } from "@ant-design/icons";

const SiderMenu = (props) => {
  const { Sider } = Layout;
  const { SubMenu } = Menu;
  const { collapsed } = props;

  const user = JSON.parse(localStorage.getItem("user"));
  
  return (
    <Sider width={230} trigger={null} collapsible collapsed={collapsed} className="site-layout-background">
      {user.role !== 4 ? (
      <Menu
        mode="inline"
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["sub1"]}
        style={{ height: "100%", borderRight: 0 }}
      >
        <SubMenu
          key="sub3"
          icon={<SolutionOutlined />}
          title="Registro de Asistencia"
        >
          <Menu.Item
            key="7"
            onClick={() => props.history.push(`/app/dias-asistencia`)}
          >
            Crear solicitud
          </Menu.Item>
          <Menu.Item
            key="8"
            onClick={() =>
              props.history.push(`/app/mis-solicitudes-asistencia`)
            }
          >
            Mis solicitudes
          </Menu.Item>
          {user.role === 3 && (
            <Menu.Item
              key="9"
              onClick={() =>
                props.history.push(
                  `/app/solicitudes-mis-empleados-asistencia`
                )
              }
            >
              Sol. mis empleados
            </Menu.Item>
          )}
        </SubMenu>
        <SubMenu
          key="sub4"
          icon={<SolutionOutlined />}
          title="Días de Permiso"
        >
          <Menu.Item
            key="10"
            onClick={() => props.history.push(`/app/dias-permiso`)}
          >
            Crear solicitud
          </Menu.Item>
          <Menu.Item
            key="11"
            onClick={() =>
              props.history.push(`/app/mis-solicitudes-permiso`)
            }
          >
            Mis solicitudes
          </Menu.Item>
          {user.role === 3 && (
            <Menu.Item
              key="12"
              onClick={() =>
                props.history.push(
                  `/app/solicitudes-mis-empleados-permisos`
                )
              }
            >
              Sol. mis empleados
            </Menu.Item>
          )}
        </SubMenu>
      </Menu>
      ) : null}
      {user.role === 4 ? (
        <Menu
        mode="inline"
        defaultSelectedKeys={["9"]}
        defaultOpenKeys={["sub5"]}
        style={{ height: "100%", borderRight: 0 }}>
        <SubMenu
          key="sub8"
          icon={<SolutionOutlined />}
          title="Registro de Asistencia"
        >
          <Menu.Item
            key="21"
            onClick={() => props.history.push(`/app/dias-asistencia-solicitudes`)}
          >
            Crear solicitud
          </Menu.Item>
          <Menu.Item
            key="22"
            onClick={() => props.history.push(`/app/asistencias-solicitudes`)}
          >
            Solicitudes
          </Menu.Item>
        </SubMenu>
          <SubMenu key="sub10" icon={<SolutionOutlined />} title="Días Permiso">
              <Menu.Item
                key="7"
                onClick={() => props.history.push(`/app/dias-permiso-solicitudes`)}
              >
                Crear solicitud
              </Menu.Item>
              <Menu.Item
                key="8"
                onClick={() => props.history.push(`/app/permisos-solicitudes`)}
                >
                  Solicitudes
              </Menu.Item>
          </SubMenu>
          <SubMenu key="sub11" icon={<SolutionOutlined />} title="RRHH">
            <Menu.Item
              key="25"
              onClick={() => props.history.push(`/app/archivos`)}
            >
              Archivos
            </Menu.Item>
            <Menu.Item
              key="26"
              onClick={() => props.history.push(`/app/reportes`)}
            >
              Reportes
            </Menu.Item>
            <Menu.Item
              key="27"
              onClick={() => props.history.push(`/app/archivos-de-salida`)}
            >
              Archivos de salida
            </Menu.Item>
          </SubMenu>
        </Menu>
      ) : null}
    </Sider>
  );
};

export default withRouter(SiderMenu);
